module.exports = __webpack_public_path__ + "img/product-air-slider.b7d48b40.jpg";